var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3z",
    fill: "#21C25E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.421 9.259v3.647H9.8a1.93 1.93 0 001.351-.546 1.779 1.779 0 000-2.555A1.93 1.93 0 009.8 9.26H7.42zM5 18.09V9.259h2.417v-2.26h2.382a4.18 4.18 0 012.923 1.191c.756.74 1.229 1.76 1.229 2.893a4.031 4.031 0 01-1.23 2.892A4.18 4.18 0 019.8 15.166H7.421v2.925H5zM16.11 5.767V8.89h3.123V5.767H16.11zm.767.766h1.59v1.59h-1.59v-1.59zM15.343 5H20v4.657h-4.657V5",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicpay);
export default __webpack_public_path__ + "static/media/picpay.7410ad5d46cc0a3618b7873308fbe515.svg";
export { ForwardRef as ReactComponent };